import { apiClient } from "./client";

export const getCategories = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    
    try {
        // Try accessing directly base url + CATEGORY as shown in screenshot (we don't know exactly what baseurl is, so we use apiClientOther)
        // If it fails with CORS, the catch block handles it with the dummy data.
        const response = await apiClient.get("/CATEGORY", {
            headers: {
                token: token,
                loginname: loginname
            }
        });
        if (response.data && response.data.Data) {
            return response.data.Data;
        }
        throw new Error("Invalid format");
    } catch (error) {
        console.warn("CATEGORY API failed (likely CORS), using dummy data", error);
        return [
            { "ID": 367, "Category": "ZEBRA" },
            { "ID": 340, "Category": "ACC" },
            { "ID": 341, "Category": "ALUMINIUM" },
            { "ID": 342, "Category": "BAMBOO" },
            { "ID": 343, "Category": "CARPET" },
            { "ID": 344, "Category": "CATLOGS" },
            { "ID": 345, "Category": "CHICK" },
            { "ID": 346, "Category": "COMPONENTS" },
            { "ID": 347, "Category": "DOORI" },
            { "ID": 348, "Category": "FABRIC" },
            { "ID": 349, "Category": "FLOORING" },
            { "ID": 350, "Category": "GLASS FILM" },
            { "ID": 351, "Category": "INDUSTRIAL CRT" },
            { "ID": 352, "Category": "LINING" },
            { "ID": 353, "Category": "MANUAL" },
            { "ID": 354, "Category": "MESH" },
            { "ID": 355, "Category": "METAL" },
            { "ID": 356, "Category": "MOTORS" },
            { "ID": 357, "Category": "PVC" },
            { "ID": 358, "Category": "REMOTE" },
            { "ID": 359, "Category": "ROLLER" },
            { "ID": 360, "Category": "ROMAN" },
            { "ID": 361, "Category": "TAPE" },
            { "ID": 362, "Category": "TRACKS" },
            { "ID": 363, "Category": "VENETION" },
            { "ID": 364, "Category": "VERTICAL" },
            { "ID": 365, "Category": "WALL-PAPER" },
            { "ID": 366, "Category": "WOODEN" }
        ];
    }
};

export const getSubCategories = async (catgId) => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    
    try {
        const response = await apiClient.get(`/SUBCATG?CATGID=${catgId}`, {
            headers: {
                token: token,
                loginname: loginname
            }
        });
        if (response.data && response.data.Data) {
            return response.data.Data;
        }
        throw new Error("Invalid format");
    } catch (error) {
        console.warn(`SUBCATG API failed for ${catgId}, using dummy data`, error);
        return [
            { "SUBCATG": "ALUM", "ID": 374, "Catgid": 363, "Category": "VENETION" },
            { "SUBCATG": "COMPONENTS", "ID": 382, "Catgid": 363, "Category": "VENETION" },
            { "SUBCATG": "WOODEN", "ID": 419, "Catgid": 363, "Category": "VENETION" }
        ];
    }
};
